import { render, staticRenderFns } from "./StudioInstructorsPreview.vue?vue&type=template&id=45b2d9e1&scoped=true&"
import script from "./StudioInstructorsPreview.vue?vue&type=script&lang=js&"
export * from "./StudioInstructorsPreview.vue?vue&type=script&lang=js&"
import style0 from "./StudioInstructorsPreview.vue?vue&type=style&index=0&id=45b2d9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2d9e1",
  null
  
)

export default component.exports